import Seo from "@/components/Seo";

export default function ComingSoon() {
  return (
    <div
      className="min-h-screen w-full flex flex-col items-center justify-center relative overflow-hidden bg-[#FBF9F5] dark:bg-[#1A0509] text-slate-900 dark:text-slate-100 px-6 select-none"
      data-testid="coming-soon-screen"
    >
      <Seo
        title="Cyannect — Coming Soon"
        description="Cyannect is coming soon. Stay tuned for our official launch."
        keywords="Cyannect, coming soon, performance commerce"
      />

      {/* Dynamic Ambient Background Blobs */}
      <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden opacity-70">
        <div className="blob blob-cyan blob-float w-[600px] h-[600px] -top-36 -right-36" />
        <div
          className="blob blob-mint blob-float w-[500px] h-[500px] -bottom-36 -left-36"
          style={{ animationDelay: "3.5s" }}
        />
        <div
          className="absolute inset-0 opacity-[0.03] dark:opacity-[0.06]"
          style={{
            backgroundImage: "radial-gradient(#004C3F 1px, transparent 1px)",
            backgroundSize: "32px 32px",
          }}
        />
      </div>

      {/* Main Centered Coming Soon Content */}
      <div className="relative z-10 flex flex-col items-center text-center max-w-2xl mx-auto py-12">
        {/* Brand Logo */}
        <div className="mb-8" data-testid="coming-soon-logo">
          <img
            src="/cyannect-logo.png"
            alt="Cyannect"
            className="h-16 sm:h-20 w-auto object-contain drop-shadow-sm"
          />
        </div>

        {/* Pulse Pill Badge */}
        <div
          className="inline-flex items-center gap-2.5 px-4 py-1.5 rounded-full bg-emerald-50 dark:bg-emerald-950/60 border border-emerald-300 dark:border-emerald-700/60 text-xs sm:text-sm font-semibold uppercase tracking-widest text-emerald-800 dark:text-emerald-300 shadow-sm mb-6"
          data-testid="coming-soon-badge"
        >
          <span className="relative flex h-2.5 w-2.5">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75" />
            <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-emerald-500" />
          </span>
          <span>Launching Soon</span>
        </div>

        {/* Main Grand Heading */}
        <h1
          className="font-display font-medium text-5xl sm:text-6xl md:text-7xl lg:text-8xl tracking-tight leading-[1.05]"
          data-testid="coming-soon-title"
        >
          Coming{" "}
          <span className="pf-gradient-text gradient-shift">Soon</span>
        </h1>

        {/* Minimalist Subtext */}
        <p
          className="mt-6 text-base sm:text-lg md:text-xl text-slate-600 dark:text-slate-300 max-w-lg leading-relaxed font-normal"
          data-testid="coming-soon-subtext"
        >
          We are putting the final touches on something extraordinary. Stay tuned.
        </p>
      </div>
    </div>
  );
}
